import React, { Component } from 'react';
import LoadingDots from '../../components/Loadingdot/Loadingdots';
import './style.css';

class PaypalPayment extends Component {
  constructor(props){
    super(props)
    this.state={
      comment:"",
      hideDispayVerify:"",
      showDivVerifyRejectBtn : true,
      showVerifyBtn: true,
      showRejectBtn: true,
      paymentStatus:"",
      paymentType:"",
      PaypalPaymentEmail: "",
     
    };
    this.showPaymentRequest = this.showPaymentRequest.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.verifyPaypal = this.verifyPaypal.bind(this);
    this.rejectPaypal = this.rejectPaypal.bind(this);
    this.PaypalPaymentPayNow = this.PaypalPaymentPayNow.bind(this);
  }

  componentDidMount(){
    if(this.props.userTransactionSuccess){
      this.setState({paymentStatus : this.props.userTransactionData.currentPay.paymentStatus,
        paymentType : this.props.userTransactionData.currentPay.paymentType,
        PaypalPaymentEmail : this.props.userTransactionData.currentPay.paypalEmailId
      });
    }
  }

  componentWillReceiveProps(nextprops){
    if(nextprops.verifySuccess === true){
      if(nextprops.verifymessage){
        this.setState({ showDivVerifyRejectBtn : false });
        alert(nextprops.verifymessage);
        this.props.stopVerifyMessage();
      }   
    }else{
      if(nextprops.verifymessage){
        alert(nextprops.verifymessage);
        this.setState({ hideDispayVerify : "none" });
        this.props.stopVerifyMessage();
      }
    }
    if(nextprops.rejectSuccess){
      if(nextprops.rejectmessage){
        this.setState({ showDivVerifyRejectBtn : false });
        alert(nextprops.rejectmessage);
        this.props.stopVerifyMessage();
        this.props.showPaymentRequest();
      }
    }else{
      if(nextprops.rejectmessage){
        this.setState({ showDivVerifyRejectBtn : false });
        alert(nextprops.rejectmessage);
        this.props.stopVerifyMessage();
        this.props.showPaymentRequest();
      }
    }
  }


  showPaymentRequest(){
    this.props.showPaymentRequest();
  }

  handleChange(e){
    this.setState({ comment : e.target.value});
      this.setState({showVerifyBtn : false,showRejectBtn : false });
  }

  verifyPaypal(){
    let data ={};
    data.transactionID = this.props.userTransactionData.currentPay._id;
    data.totalAmount = this.props.userTransactionData.currentPay.totalAmount;
    data.totalPoints = this.props.userTransactionData.currentPay.totalPoints;
    data.userID = this.props.userTransactionData.currentPay.user_id;
    data.paymentType = this.props.userTransactionData.currentPay.paymentType;
    data.deliveryType = this.props.userTransactionData.currentPay.deliveryType;
    data.comment = this.state.comment;
    let adminToken=sessionStorage.getItem("adminToken");
    data.token = adminToken;
    this.props.verifyPaypal(data);
    this.setState({ comment : ""});
  }

  rejectPaypal(){
    let data ={};
    data.transactionID = this.props.userTransactionData.currentPay._id;    
    data.userID = this.props.userTransactionData.currentPay.user_id;
    data.comment = this.state.comment;
    let adminToken=sessionStorage.getItem("adminToken");
    data.token = adminToken;
    this.props.rejectPaypal(data);
    this.setState({ comment : ""});
  }

  PaypalPaymentPayNow(){
    let data ={};
    data.paypalEmailId = this.state.PaypalPaymentEmail;
    data.transactionID = this.props.userTransactionData.currentPay._id;    
    data.userID = this.props.userTransactionData.currentPay.user_id;
    data.totalAmount = this.props.userTransactionData.currentPay.totalAmount;
    this.props.paypalPaymentPayUser(data);
  }

  render(){

    let showLastPayment ="";
    let showReqPayment = ""
    if(this.props.userTransactionSuccess){
      if(this.props.userTransactionData.successPay){
        showLastPayment = 
        <div>
          <h4>Last success payment :</h4>
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  Amount :  {this.props.userTransactionData.successPay.totalAmount},&nbsp;USD&nbsp;&nbsp;&nbsp;  Points : {this.props.userTransactionData.successPay.totalPoints}                 
        </div>
      }


      if(this.props.userTransactionData.currentPay){
        showReqPayment = 
        <div><h4>Current Transaction:</h4>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Requested Amount :  {this.props.userTransactionData.currentPay.totalAmount} &nbsp; USD,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total points : {this.props.userTransactionData.currentPay.totalPoints}<br/>
        </div>
      }
    }

    let showVerifyRejectButton = "";

    if(this.state.paymentStatus === "approved" && this.state.paymentType === "paypal"){
      showVerifyRejectButton =  <div className = "VerifyRejectPayDiv">
       Paypal payment email : &nbsp;&nbsp; {this.state.PaypalPaymentEmail}
      <button onClick= {this.PaypalPaymentPayNow}>Paynow </button></div>
    }else if(this.state.showDivVerifyRejectBtn){
      showVerifyRejectButton = <div>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<textarea name="comment"
                  onChange={this.handleChange}
                  placeholder = "Please enter comments"
                  value={this.state.comment}/><br/>
        <div className = "VerifyRejectDiv" style={{display: this.state.hideDispayVerify }}><button  disabled = {this.state.showVerifyBtn} onClick = {this.verifyPaypal}>Verify</button></div>
      
        <div className = "VerifyRejectDiv"><button  disabled = {this.state.showRejectBtn} onClick = {this.rejectPaypal}>Reject</button></div>
      </div>
    }else{
      showVerifyRejectButton = 
      <div className = "VerifyRejectPayDiv">
      Paypal payment email : &nbsp;&nbsp; {this.state.PaypalPaymentEmail}
      <button onClick= {this.PaypalPaymentPayNow}>Paynow </button></div>
    }
    
    let showloading =""
    if(this.props.requestStarted){
      showloading =  <div className="loading">
      {
        this.props.requestStarted?
        <div className="preloader"><LoadingDots interval={100} dots={5} /></div>
        :
        false
         }</div>
    }else if(this.props.userPaySuccess){
      showloading =<div className = "VerifyRejectPayDiv">
      Paypal transactionId : &nbsp;&nbsp; {this.props.userPayData.payoutTxnId}<br/>
      Total amount : &nbsp;&nbsp; {this.props.userPayData.totalAmount}&nbsp;USD<br/>
      Paypal success : &nbsp;&nbsp; {this.props.userPayData.payoutTxnStatus}<br/>

     <button onClick= {this.showPaymentRequest}> Go to payments </button></div>
    } else if(this.props.resCheckPalPalPaymentStatus){

      let tranasctionsEmailErrorDiv ="";
    if(this.props.resCheckPalPalPaymentData.tranactionFailError){
      tranasctionsEmailErrorDiv= <div>
      Error type &nbsp;&nbsp;: &nbsp;&nbsp;{this.props.resCheckPalPalPaymentData.tranactionFailError.name.toLowerCase()}<br/><br/>
      Error &nbsp;&nbsp;&nbsp;&nbsp; : &nbsp;&nbsp;{this.props.resCheckPalPalPaymentData.tranactionFailError.message}
      </div>
    }
      
      console.log(this.props.resCheckPalPalPaymentData);
      showloading = <div className = "VerifyRejectPayDiv">
      Paypal Transaction email id : &nbsp;&nbsp; {this.props.resCheckPalPalPaymentData.tranasctionsEmail}<br/><br/>
      Paypal Transaction status&nbsp;&nbsp;   : &nbsp;&nbsp; {this.props.resCheckPalPalPaymentData.transactionStatus.toLowerCase()}<br/><br/>
      {tranasctionsEmailErrorDiv}
      </div>
    } else{
       showloading=<div>
          {showLastPayment}<br/>
          {showReqPayment}<br/>
          {showVerifyRejectButton}<br/> </div>
    }


    return (
      <div className = "regPage">
       <div className = "form">
        <div className = "GNNheading"><h1>Paypal Payment</h1></div> 
          <br/><button  className = "backbutton" onClick = {this.showPaymentRequest} >Back</button><br/>  
          <div className = "registerform">       
          {showloading}
          </div>
        </div>
      </div>
    );
  }
}
export default PaypalPayment;



// WEBPACK FOOTER //
// ./src/components/PaymentRequest/paypal.js